import React from "react";

export const RightArrow = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.5"
      y="0.5"
      width="31"
      height="31"
      rx="15.5"
      fill="var(--btn-fill, white)"
    />
    <rect
      x="0.5"
      y="0.5"
      width="31"
      height="31"
      rx="15.5"
      stroke="var(--btn-stroke, #D8DBE0)"
    />
    <path
      d="M14.5 11.5L19 16L14.5 20.5"
      stroke="black"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
